import { createSelector } from 'reselect';

const getRpsSubscriptionInformation = (state) =>
  state.rpsSubscriptionInformation || {};

export const isEligibleForRps = createSelector(
  getRpsSubscriptionInformation,
  (rps) => (rps && rps.eligible ? rps.eligible : false)
);

export const isSubscribedToRps = createSelector(
  getRpsSubscriptionInformation,
  (rps) => (rps && rps.subscribed ? rps.subscribed : false)
);
